import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

@Controller({ fragment: 'root' })
class MainController {

  @OnMount({ target: 'root-layout' })
  onRootLayoutMount(): void {
    document.title = MessageService.translate('application.name');
  }
}

export default MainController;
